import React from 'react';

export const Edit = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0274 9.47259C15.4956 6.20202 16.0318 6.0369 19.5 2.76634L21.5226 4.73769L14.0274 11.4726L12.0274 9.47259Z"
      fill="black"
      stroke="black"
      strokeWidth="1.5"
    />
    <path d="M8 15H11L13 13.5L10 10.5L8 12V15Z" fill="black" />
    <path d="M20 15.7333V20H4V4H8.26667" stroke="black" strokeWidth="1.5" />
  </svg>
);
